import { render, staticRenderFns } from "./AffiliatesTable.vue?vue&type=template&id=37f2dcda&"
import script from "./AffiliatesTable.vue?vue&type=script&lang=js&"
export * from "./AffiliatesTable.vue?vue&type=script&lang=js&"
import style0 from "./AffiliatesTable.vue?vue&type=style&index=0&id=37f2dcda&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports